import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  FormControl,
  InputLabel,
  List,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Link,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import ReactECharts from "echarts-for-react";
import AvatarImage from "../../../../images/Avatar.svg";

const Leaderboard = ({
  topusers,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  selectedCapability,
  setSelectedCapability,
  capabilities,
}) => {
  const [showMore, setShowMore] = useState(false);

  const sortedTopUsers = [...topusers.slice(0, 3)].sort(
    (a, b) => b.tokens_used - a.tokens_used
  );

  const chartOptions = {
    xAxis: { type: "category", show: false },
    yAxis: { type: "value", show: false }, // Hides the value borders
    grid: { left: 0, right: 0, top: 0, bottom: 0 }, // Optional, for tighter fit
    series: [
      {
        // data: [30, 500, 15],
        data: [
          sortedTopUsers[1]?.tokens_used, // 2nd place (left)
          sortedTopUsers[0]?.tokens_used, // 1st place (middle)
          sortedTopUsers[2]?.tokens_used, // 3rd place (right)
        ],
        type: "bar",
        itemStyle: {
          // color: {
          //   type: "radial",
          //   x: 1,
          //   y: 0.8,
          //   r: 0.5,
          //   colorStops: [
          //   //  {offset :0, color: 'radial'},
          //     { offset: 0, color: "#E9EDFB" }, // Lighter center
          //     { offset: 1, color: "#F2F5FF" } // Slightly darker edge
          //   ]
          // },
          color: {
            type: "radial",
            x: 1,
            y: 2.5, // Pulls the gradient upward to darken the top more
            r: 5,
            colorStops: [
              { offset: 0, color: "#DCE1F8" }, // Even lighter center
              { offset: 0.5, color: "#E9EDFB" }, // Soft transition
              { offset: 1, color: "#C3C8E8" }, // Darker upper portion
            ],
          },
          borderWidth: 0, // No borders
          borderRadius: [10, 10, 0, 0],
        },
      },
    ],
  };

  return (
    // <Box></Box>
    <Card
      sx={{
        maxWidth: "400px",
        minHeight: "451px",
        margin: "auto",
        marginLeft: "10px",
        p: 1,
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "16px", color: "grey" }}
        >
          Users Leaderboard
        </Typography>
        <FormControl
          sx={{
            mt: -4,
            ml: { xs: 0, sm: 10, md: 27 },
            minWidth: 120, // responsive margin-left
          }}
          size="small"
        >
          <InputLabel id="capability-name-label">Capability</InputLabel>
          <Select
            labelId="capability-name-label"
            value={selectedCapability}
            onChange={(e) => setSelectedCapability(e.target.value)}
            label="Capability"
          >
            {capabilities.map((cap) => (
              <MenuItem key={cap.capability_name} value={cap.capability_name}>
                {cap.capability_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: -1.8,
          }}
        >
          <TextField
            label="From"
            variant="outlined"
            margin="normal"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{
              shrink: true, // This keeps the label always above the input field
            }}
            sx={{
              width: "43%",
              height: "20px",
              "& input": {
                appearance: "none", // Removes the default placeholder
              },
            }}
          />
          <TextField
            label="To"
            variant="outlined"
            margin="normal"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            sx={{
              width: "43%",
              // height: "20px",
              "& input": {
                appearance: "none", // Removes the default placeholder
              },
            }}
            inputProps={{
              min: fromDate || "",
            }}
            disabled={!fromDate}
          />
          {/* <Button
                      sx={{
                        textTransform: "none",
                        variant: "outlined",
                        width: "20%",
                        height: "40px",
                        marginTop: "23px",
                        backgroundColor: "#49a3ff",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#49a3ff",
                        },
                      }}
                      // onClick={handleFilterTopServices}
                    >
                      Apply
                    </Button> */}
        </Box>
        <Divider
          sx={{
            marginTop: 1.5,
            marginBottom: 1,
            borderColor: "#eee",
            width: "110%", // Increase width beyond the container
            marginLeft: "-5%", // Extend beyond the left
            marginRight: "-5%",
          }}
        />
        <Box
          display="flex"
          justifyContent="space-around"
          alignItems="flex-end"
          py={2}
        >
          {[topusers[1], topusers[0], topusers[2]]
            .filter(Boolean)
            .map((user, index) => (
              <Box
                key={user.display_name}
                textAlign="center"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "4px", // Optional: adds some space between avatar and text
                  transform:
                    index === 1
                      ? "translateY(-10px)"
                      : index === 0
                      ? "translateY(10px)"
                      : "translateY(20px)",
                }}
              >
                <Avatar
                  src={AvatarImage}
                  sx={{
                    width: 50,
                    height: 80,
                    //transform: index === 1 ? "translateY(-10px)" : index === 0 ? "translateY(10px)" : "translateY(20px)"
                  }}
                />
                <Typography variant="body2" fontWeight="bold" fontSize={14}>
                  {user.display_name}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ color: "#9C9C9C" }}
                >
                  {Math.floor(user.tokens_used / 100)}pt
                </Typography>
              </Box>
            ))}
        </Box>
        <ReactECharts option={chartOptions} style={{ height: 90 }} />
        {/* <br /> */}
        <List>
          {topusers.slice(3, 6).map((user, index) => (
            <Box
              key={user.display_name}
              //elevation={3} // Adds a shadow effect
              sx={{
                padding: 1.5,
                display: "flex",
                alignItems: "center",
                borderRadius: 2,

                border: "1px ",
                marginBottom: 1, // Adds space between boxes
                // backgroundColor: "#D9D9D9",
                height: 20, // Decreased height
                backgroundColor: "#f9f9f9", // Light background color
                boxShadow: "2px 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              <Typography variant="body2" sx={{ minWidth: 30 }}>
                {index + 4}.
              </Typography>
              <ListItemAvatar sx={{ marginRight: 1 }}>
                <Avatar src={AvatarImage} sx={{ width: 30, height: 40 }} />
              </ListItemAvatar>
              <ListItemText
                primary={user.display_name}
                primaryTypographyProps={{ fontWeight: "bold", fontSize: "" }}
              />
              {/* Tokens aligned to the right */}
              <Typography
                variant="body2"
                color="text.secondary"
                fontWeight="bold"
                sx={{ marginLeft: "auto", color: "#9C9C9C", fontSize: "" }}
              >
                {Math.floor(user.tokens_used / 100)}pt
              </Typography>
            </Box>
          ))}

          {showMore &&
            topusers.slice(2, 20).map((user, index) => (
              <Box
                key={user.display_name}
                sx={{
                  padding: 1.5,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 2,
                  marginBottom: 1,
                  height: 20,
                  backgroundColor: "#f9f9f9",
                  boxShadow: "2px 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                <Typography variant="body2" sx={{ minWidth: 30 }}>
                  {index + 7}.
                </Typography>
                <ListItemAvatar sx={{ marginRight: 1 }}>
                  <Avatar src={AvatarImage} sx={{ width: 30, height: 40 }} />
                </ListItemAvatar>
                <ListItemText
                  primary={user.display_name}
                  primaryTypographyProps={{ fontWeight: "bold", fontSize: "" }}
                />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight="bold"
                  sx={{ marginLeft: "auto", color: "#9C9C9C", fontSize: "" }}
                >
                  {Math.floor(user.tokens_used / 100)}pt
                </Typography>
              </Box>
            ))}
        </List>
        <Divider sx={{ marginBottom: 1, borderColor: "#eee", width: "100%" }} />{" "}
        {/* Thin Divider */}
        <Box textAlign="center" mt={1}>
          <Link
            href="#"
            underline="hover"
            color="#0094FB"
            fontWeight="bold"
            fontSize={14}
            onClick={(e) => {
              e.preventDefault();
              setShowMore(!showMore);
            }}
          >
            {showMore ? "View Less" : "View More"}
          </Link>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Leaderboard;
